import { yupResolver } from '@hookform/resolvers/yup';
import { CustomInputSelect, CustomTextInput } from '@Modules/core/components';
import AppLoader from '@Modules/core/components/Loader';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import React from 'react';
import { useForm } from 'react-hook-form';
import { IUsersManagementFormMeta } from '../../containers/formHandlers/UsersManagementFormHandle/UsersManagementFormMeta';

type Props = {
  onSubmit: any,
  meta: IUsersManagementFormMeta,
  isLoading: boolean,
};

export default React.forwardRef(function UsersManagementFormUI(
  { onSubmit, meta, isLoading }: Props,
  ref: any
) {
  const submitBtnRef = React.useRef<any>(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
    // reset,
  } = useForm({ resolver: yupResolver(meta.schema) });

  React.useImperativeHandle(ref, () => ({
    submitBtnRef,
  }));

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <CC.Box>
          <CC.Text mb="4" color="gray.600">
            Remplissez les informations de base de l'utilisateur
            {isLoading && <AppLoader />}
          </CC.Text>

          <CC.Box w="full" mt="4" mb="8">
            <CC.Flex w="full" mb="4">
              <CC.FormControl mr="2">
                <CC.FormLabel>{meta.firstName.label}</CC.FormLabel>
                <CustomTextInput
                  meta={meta.firstName}
                  register={register(meta.firstName.name)}
                  hasError={errors[meta.firstName.name]}
                />
              </CC.FormControl>

              <CC.FormControl mr="2">
                <CC.FormLabel>{meta.lastName.label}</CC.FormLabel>
                <CustomTextInput
                  meta={meta.lastName}
                  register={register(meta.lastName.name)}
                  hasError={errors[meta.lastName.name]}
                />
              </CC.FormControl>

              <CC.FormControl>
                <CC.FormLabel>{meta.sex.label}</CC.FormLabel>
                <CustomInputSelect
                  meta={meta.sex}
                  register={register(meta.sex.name)}
                  hasError={errors[meta.sex.name]}
                />
              </CC.FormControl>
            </CC.Flex>
          </CC.Box>

          <CC.Box>
            <CC.FormControl mr="2">
              <CC.FormLabel>{meta.position.label}</CC.FormLabel>
              <CustomTextInput
                meta={meta.position}
                register={register(meta.position.name)}
                hasError={errors[meta.position.name]}
              />
            </CC.FormControl>
          </CC.Box>

          <CC.Box w="full" mt="4" mb="8">
            <CC.Flex w="full" mb="4">
              <CC.FormControl mr="2">
                <CC.FormLabel>{meta.birthDate.label}</CC.FormLabel>
                <CustomTextInput
                  meta={meta.birthDate}
                  register={register(meta.birthDate.name)}
                  hasError={errors[meta.birthDate.name]}
                />
              </CC.FormControl>

              <CC.FormControl mr="2">
                <CC.FormLabel>{meta.birthPlace.label}</CC.FormLabel>
                <CustomTextInput
                  meta={meta.birthPlace}
                  register={register(meta.birthPlace.name)}
                  hasError={errors[meta.birthPlace.name]}
                />
              </CC.FormControl>

              <CC.FormControl>
                <CC.FormLabel>{meta.email.label}</CC.FormLabel>
                <CustomTextInput
                  meta={meta.email}
                  register={register(meta.email.name)}
                  hasError={errors[meta.email.name]}
                />
              </CC.FormControl>
            </CC.Flex>
          </CC.Box>

          <CC.Box w="full" mt="4" mb="8">
            <CC.Flex w="full" mb="4">
              <CC.FormControl mr="2">
                <CC.FormLabel>{meta.username.label}</CC.FormLabel>
                <CustomTextInput
                  meta={meta.username}
                  register={register(meta.username.name)}
                  hasError={errors[meta.username.name]}
                />
              </CC.FormControl>

              <CC.FormControl mr="2">
                <CC.FormLabel>{meta.password.label}</CC.FormLabel>
                <CustomTextInput
                  meta={meta.password}
                  register={register(meta.password.name)}
                  hasError={errors[meta.password.name]}
                />
              </CC.FormControl>

              <CC.FormControl>
                <CC.FormLabel>{meta.confirmPassword.label}</CC.FormLabel>
                <CustomTextInput
                  meta={meta.confirmPassword}
                  register={register(meta.confirmPassword.name)}
                  hasError={errors[meta.confirmPassword.name]}
                />
              </CC.FormControl>
            </CC.Flex>
          </CC.Box>

          {/* <CC.Box>
          <CC.FormControl mr="2">
            <CC.FormLabel>{meta.position.label}</CC.FormLabel>
            <CustomTextInput
              meta={meta.position}
              register={register(meta.position.name)}
              hasError={errors[meta.position.name]}
            />
          </CC.FormControl>
        </CC.Box> */}

          <button
            ref={submitBtnRef}
            type="submit"
            style={{ display: 'none' }}
          ></button>

          {/* <CC.Flex justify={'flex-end'}>
          <CustomButton type="submit" >
            {isLoading ? <AppLoader /> : <span>Sauvegarder</span>}
          </CustomButton>
        </CC.Flex> */}
        </CC.Box>
      </form>
    </>
  );
});
